var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallWhiteBank = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/tertiary/bank") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "display/small/tertiary/bank",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_78_-Copy",
    transform: "translate(1.7022, 1.8958)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7536,23.58315 L1.1826,23.58315 C0.5346,23.58315 0,24.11775 0,24.76575 C0,25.41375 0.5346,25.94835 1.1826,25.94835 L24.7536,25.94835 C25.4016,25.94835 25.9362,25.41375 25.9362,24.76575 C25.9362,24.11775 25.4016,23.58315 24.7536,23.58315 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6568,20.52135 C2.0088,20.52135 1.4742,21.05595 1.4742,21.70395 C1.4742,22.35195 2.0088,22.88655 2.6568,22.88655 L23.2794,22.88655 C23.9274,22.88655 24.462,22.35195 24.462,21.70395 C24.462,21.05595 23.9274,20.52135 23.2794,20.52135 L22.9878,20.52135 L22.9878,9.91035 L23.2794,9.91035 C23.6034,9.91035 23.8626,9.65115 23.8626,9.32715 C23.8626,9.00315 23.6034,8.74395 23.2794,8.74395 L2.6568,8.74395 C2.3328,8.74395 2.0736,9.00315 2.0736,9.32715 C2.0736,9.65115 2.3328,9.91035 2.6568,9.91035 L2.9484,9.91035 L2.9484,20.52135 L2.6568,20.52135 L2.6568,20.52135 Z M20.6226,9.91035 L20.6226,20.52135 L17.091,20.52135 L17.091,9.91035 L20.6226,9.91035 Z M14.7258,9.91035 L14.7258,20.52135 L11.1942,20.52135 L11.1942,9.91035 L14.7258,9.91035 Z M5.2974,9.91035 L8.829,9.91035 L8.829,20.52135 L5.2974,20.52135 L5.2974,9.91035 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.1826,7.67475 L24.7536,7.67475 C24.7536,7.67475 24.7698,7.67475 24.7698,7.67475 C25.4178,7.67475 25.9524,7.14015 25.9524,6.49215 C25.9524,5.97375 25.6122,5.53635 25.1586,5.37435 L13.4622,0.10935 C13.1544,-0.03645 12.798,-0.03645 12.4902,0.10935 L0.6966,5.40675 C0.1944,5.63355 -0.0972,6.18435 0.0324,6.73515 C0.1458,7.28595 0.6156,7.67475 1.1826,7.67475 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallWhiteBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-white-bank.64e4b5a9dc41825b5cfe653c8115efb7.svg";